module.exports = __webpack_public_path__ + "img/success.b0f54525.png";